<app-text [ngClass]="textClass" class="title" [text]="text"></app-text>
<app-text *ngIf="subtext !== ''" [ngClass]="subTextClass" class="subtitle" [text]="subtext"></app-text>
